const noSpaces = (s: string) => s.replace(/\s/g, '-');

export default noSpaces;
